import React from 'react';
import { Image, Dropdown } from 'react-bootstrap';
import { S3_URL, USER_TYPES } from 'constants/index';
import { IMAGE_PATHS } from 'constants/imagePaths';

interface SocialPostHeaderProps {
	profilePicture?: string;
	userName?: string;
	userLocation?: string;
	created?: string;
	userType?: string;
	userId?: number | string;
	token?: string;
	withAuth: (token: string | undefined, callback: () => void) => () => void;
	redirectToProfile: () => void;
	postId: number | string;
	user?: {
		userId?: number | string;
	};
	setModalConfig: (config: {
		visible: boolean;
		id: number | string;
		type: string;
		onClick?: () => void;
		onClose?: () => void;
		contentType?: string;
		props?: {
			size?: string;
		};
	}) => void;
	handleModalClick: (payload?: any) => void;
	blockUserModal: () => void;
	hideCommonModal: () => void;
	onHandleDelete: (postId: number | null) => void;
	translate: (key: string) => string;
}

const SocialPostHeader: React.FC<SocialPostHeaderProps> = ({
	profilePicture,
	userName,
	userLocation,
	created,
	userType,
	userId,
	token,
	withAuth,
	redirectToProfile,
	postId,
	user,
	setModalConfig,
	handleModalClick,
	blockUserModal,
	hideCommonModal,
	onHandleDelete,
	translate,
}) => (
	<div className="social-post-header position-relative d-flex justify-content-between align-items-center">
		<div className="post-profile d-flex flex-column flex-sm-row align-items-baseline align-items-sm-center gap-2 gap-xxl-3">
			<div className="post-profile-img rounded-circle" onClick={withAuth(token, redirectToProfile)}>
				<Image
					src={
						profilePicture?.length !== 0
							? `${S3_URL}${profilePicture}`
							: userType === USER_TYPES?.COMPANY
								? IMAGE_PATHS.CompanyLogoDefault
								: IMAGE_PATHS.UserDefault
					}
					className="w-100 h-100 object-fit-cover rounded-circle"
					loading="lazy"
					alt="profile-pic"
				/>
			</div>
			<div>
				{userName && (
					<h5 onClick={withAuth(token, redirectToProfile)} className="fw-bold mb-1">
						{userName}
					</h5>
				)}
				<div className="post-profile-detail d-flex align-items-center flex-wrap">
					{userLocation && <p className="mb-0">{userLocation}</p>}
					{created && <p className="mb-0">{created}</p>}
				</div>
			</div>
		</div>
		<div className="post-profile-actions d-flex gap-2 gap-xxl-3">
			<div className="edit-action">
				<Dropdown>
					<Dropdown.Toggle variant="success" id="dropdown-basic" className="p-0 rounded-circle">
						<i className="ri-more-2-fill"></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{userId !== user?.userId ? (
							<>
								<Dropdown.Item
									onClick={withAuth(token, () => {
										setModalConfig({
											visible: true,
											id: Number(postId),
											onClick: handleModalClick,
											type: 'reportFeeds',
											contentType: 'socialPost',
										});
									})}
								>
									<i className="ri-flag-line"></i> {translate('Report.report')}
								</Dropdown.Item>
								<Dropdown.Item onClick={withAuth(token, blockUserModal)}>
									<i className="ri-spam-2-line"></i> {translate('Report.block')}
								</Dropdown.Item>
							</>
						) : (
							<>
								<Dropdown.Item
									onClick={withAuth(token, () => {
										setModalConfig({
											visible: true,
											id: postId,
											type: 'createNewPost',
											onClose: hideCommonModal,
											props: {
												size: 'lg',
											},
										});
									})}
								>
									<i className="ri-edit-line"></i> {translate('Common.edit')}
								</Dropdown.Item>
								<Dropdown.Item onClick={withAuth(token, () => onHandleDelete(postId))}>
									<i className="ri-delete-bin-7-line"></i> {translate('Common.delete')}
								</Dropdown.Item>
							</>
						)}
					</Dropdown.Menu>
				</Dropdown>
			</div>
		</div>
	</div>
);

export default SocialPostHeader;
